import { isNumber } from "lodash";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import { CaseSpecimenAdmin } from "pwapi";

import { CaseAdminDetail } from "shared/reducers/admin/adminCaseReducer";

import AdminPanel from "components/admin/adminPanel/AdminPanel";
import SpecimenWarningDialog from "components/admin/editCasePanel/SpecimenWarningDialog";
import HalfScreenPanel from "components/admin/editPanels/halfScreenEditPanel/HalfScreenPanel";
import DjangoLink from "components/DjangoLink";

import SpecimenForm from "./SpecimenForm";

type SpecimensPanelProps = {
  returnUrl: string;
  adminCase: CaseAdminDetail;
  specimenId: number | string;
  canUpdateSpecimen?: boolean;
};

const SpecimensPanel = ({
  returnUrl,
  adminCase,
  specimenId,
  canUpdateSpecimen = true,
}: SpecimensPanelProps) => {
  const navigate = useNavigate();

  const [delSpecimen, setDelSpecimen] = useState<boolean>(false);

  const specimen = useMemo(() => {
    return isNumber(specimenId)
      ? adminCase.specimens?.find((spec) => spec.id === specimenId)
      : ({
          name: "",
          protocol_overrides: [],
          collected_date: adminCase.collected_date,
          received_date: adminCase.received_date,
          case: adminCase.id,
        } as CaseSpecimenAdmin);
  }, [specimenId, adminCase.specimens]);

  const handleOnClose = () => {
    navigate(returnUrl, { replace: true });
  };

  if (!specimen) return null;

  return (
    <>
      {delSpecimen && (
        <SpecimenWarningDialog
          adminCase={adminCase}
          specimen={specimen}
          onClose={() => setDelSpecimen(false)}
          onClosePanel={handleOnClose}
        />
      )}
      <HalfScreenPanel onClose={handleOnClose}>
        <div className="HalfScreen__container">
          <AdminPanel
            title={{
              prefix: specimen?.id
                ? `Specimen #${specimen.id}`
                : `Add Specimen to ${adminCase.accession}`,
              main: specimen?.id ? specimen.name : "Create New Specimen",
            }}
            djangoLink={
              <DjangoLink
                route={
                  specimen?.id
                    ? `histoslide/specimen/${specimen.id}/change/`
                    : `histoslide/specimen`
                }
                title="Django Specimen Access"
              />
            }
          >
            <SpecimenForm
              specimen={specimen}
              adminCase={adminCase}
              onClose={handleOnClose}
              setDelSpecimen={setDelSpecimen}
              disableSubmit={!canUpdateSpecimen}
            />
          </AdminPanel>
        </div>
      </HalfScreenPanel>
    </>
  );
};

export default SpecimensPanel;
